import { styled } from "goober";
import type { Connector } from "../../lib/connector";
import { ConnectorLogo } from "../ConnectorLogo";
import { ConnectorLogoContainer } from "../ConnectorLogoContainer";
import { HeaderTitleStack } from "../HeaderTitleStack";
import { HeaderLeft } from "../SettingsLayout";
import { Text } from "../Text";

export const Header = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
`;

export function ConnectorHeading({
  app,
  title,
  subtitle,
}: {
  app: Connector;
  title: string;
  subtitle?: string;
}) {
  return (
    <HeaderLeft>
      <ConnectorLogoContainer
        size={32}
        borderRadius={8}
        hoverBackground={false}
      >
        <ConnectorLogo app={app} size={16} />
      </ConnectorLogoContainer>
      <HeaderTitleStack>
        <Text variant="text-regular-md" color="var(--text-primary)" ellipsis>
          {title}
        </Text>
        {subtitle && (
          <Text variant="text-small" color="var(--text-secondary)" ellipsis>
            {subtitle}
          </Text>
        )}
      </HeaderTitleStack>
    </HeaderLeft>
  );
}
